<div style="font-size: xxx-large; text-align: center; margin-top: 100px">
  {{ 'COMPANY.DONT_HAVE_ACCESS' | translate }}
  <div class="not-found full-background-text">
    <h4>{{ 'COMPANY.PLS_CHECK_COMPANY' | translate }}</h4>
    <div class="mt-3" *ngIf="showBackToDashboardButton">
      <button type="button" class="primary-button" routerLink="/dashboard">
        {{ 'COMPANY.GO_BACK_DASHBOARD' | translate }}
      </button>
    </div>
  </div>
</div>
